import { API } from "@/services"

export const LOAD_TEST_ENDPOINTS = {
  create(data={}){
    return API.Axios.automation.v1.request({
      url: `load-test`,
      method: 'POST',
      data,
    })
  },
  list(params={}){
    return API.Axios.automation.v1.request({
      url: `load-test`,
      method: 'GET',
      params,
    })
  },
  findById(id='',params={}){
    return API.Axios.automation.v1.request({
      url: `load-test/${id}`,
      method: 'GET',
      params,
    })
  },
  delete(id='',data={}){
    return API.Axios.automation.v1.request({
      url: `load-test/${id}`,
      method: 'DELETE',
      data,
    })
  },
  update(id='',data={}){
    return API.Axios.automation.v1.request({
      url: `load-test/${id}`,
      method: 'PUT',
      data,
    })
  },
  start(id='',data={}){
    return API.Axios.automation.v1.request({
      url: `load-test/${id}/start`,
      method: 'PATCH',
      data,
    })
  },
  pause(id='',data={}){
    return API.Axios.automation.v1.request({
      url: `load-test/${id}/pause`,
      method: 'PATCH',
      data,
    })
  },
  getHeartbeats(id='',params={}){
    return API.Axios.automation.v1.request({
      url: `load-test/${id}/heartbeats`,
      method: 'GET',
      params,
    })
  },
  getHeartbeat(id='',load_test_heartbeat_id='',params={}){
    return API.Axios.automation.v1.request({
      url: `load-test/${id}/heartbeats/${load_test_heartbeat_id}`,
      method: 'GET',
      params,
    })
  },
}